<div
  class="chart-container"
  [cdkContextMenuTriggerFor]="contextMenu"
  (contextmenu)="onRightClick($event)"
>
  <si-chart
    #chart
    echarts
    class="sichart bg-base-1"
    renderer="svg"
    [options]="chartOption()"
    [zoomSlider]="true"
    [zoomInside]="true"
    (siResizeObserver)="chart.resize()"
  />
</div>

<ng-template #contextMenu>
  <si-menu (closed)="resetContextMenu()">
    <!-- Add data point only -->
    @if (contextMenuState().type === 'add') {
      <si-menu-item class="context-menu-item" (click)="addDataPointAtPosition()">
        <span
          >Add point: {{ contextMenuState().displayPosition }} /
          {{ contextMenuState().displayValue }}</span
        >
      </si-menu-item>
    }

    <!-- Download submenu (only when not in edit mode) -->
    @if (!editModeControl.value) {
      <si-menu-item class="context-menu-item" [cdkMenuTriggerFor]="fileTypes">
        Download as
      </si-menu-item>
    }
  </si-menu>
</ng-template>

<ng-template #fileTypes>
  <si-menu>
    <si-menu-item class="context-menu-item" (click)="downloadChartAsSVG()">SVG</si-menu-item>
  </si-menu>
</ng-template>

<!-- Comment Dialog Component -->
<app-track-plot-comment
  [dataKey]="dataKey()"
  [commentDialogState]="commentDialogState()"
  (commentSaved)="onCommentSaved($event)"
  (commentClosed)="onCommentClosed()"
/>
